import { Button, Radio, Stack, Typography } from '@mui/material';

export type CardProps = {
    hasRadio?: boolean;
    overline?: string;
    title: string;
    subtitle?: string;
    rigthIcon?: React.ReactNode;
    image?: string;
    placeholderVariant?: string;
    placeholder?: string;
    leftButtonText?: string;
    leftButtonOnClick?: () => void;
    rightButtonText?: string;
    rightButtonOnClick?: () => void;
};

const Card = ({
    hasRadio,
    overline,
    title,
    subtitle,
    rigthIcon,
    image,
    placeholderVariant,
    placeholder,
    leftButtonText,
    leftButtonOnClick,
    rightButtonText,
    rightButtonOnClick,
}: CardProps) => {
    return (
        <Stack border={'1px solid lightgray'} borderRadius='4px'>
            <Stack
                direction='row'
                spacing={1}
                justifyContent={'space-between'}
                alignItems={'center'}
                py={1.5}
                pl={2}
                pr={1}
                borderBottom={'1px solid lightgray'}
            >
                <Stack direction='row' spacing={1} alignItems='center'>
                    {hasRadio && (
                        <Radio
                            size='large'
                            checked={true}
                            color='secondary'
                            disabled={false}
                            name='change-radio-button'
                        />
                    )}
                    <Stack spacing={0.5} textAlign='left'>
                        {overline && (
                            <Typography variant='overline' color='primary.mui.inactive'>
                                {overline}
                            </Typography>
                        )}
                        <Typography variant='h6' color='primary'>
                            {title}
                        </Typography>
                        {subtitle && (
                            <Typography variant='body2' color='primary.mui.inactive'>
                                {subtitle}
                            </Typography>
                        )}
                    </Stack>
                </Stack>
                {rigthIcon}
            </Stack>
            {image}
            {placeholder && (
                <Typography
                    variant={placeholderVariant || 'body2'}
                    color='primary'
                    align='left'
                    p={2}
                    borderBottom={'1px solid lightgray'}
                >
                    {placeholder}
                </Typography>
            )}
            {(leftButtonText || rightButtonText) && (
                <Stack
                    direction={leftButtonText ? 'row' : 'row-reverse'}
                    px={1}
                    py={0.25}
                    spacing={2}
                    alignItems='center'
                    justifyContent='space-between'
                >
                    {leftButtonText && (
                        <Button variant='contained' color='secondary' size='small' onClick={leftButtonOnClick}>
                            {leftButtonText}
                        </Button>
                    )}
                    {rightButtonText && (
                        <Button variant='text' color='secondary' size='small' onClick={rightButtonOnClick}>
                            {rightButtonText}
                        </Button>
                    )}
                </Stack>
            )}
        </Stack>
    );
};

export default Card;
